import { useInView } from "framer-motion";
import React, { useEffect, useRef, useState } from "react";
import Image from "next/image";

function LazyVideo(props) {
  const {
    videoSrc,
    image,
    setIsHeroVideoLoaded,
    shouldPause,
    customClasses = "",
    priority = false,
    ...rest
  } = props;
  const ref = useRef();
  const inView = useInView(ref, { amount: 0.001});
  const [videoLoaded, setVideoLoaded] = useState(false);
  const [videoPlaying, setVideoPlaying] = useState(false);

  const handleVideoPlay = () => {
    setVideoLoaded(true);
    if (setIsHeroVideoLoaded) {
      setIsHeroVideoLoaded(true);
    }
  };

  const handleVideoNotPlay = () => {
    if (setIsHeroVideoLoaded) {
      setIsHeroVideoLoaded(true);
    }
  };

  const handleOnPlaying = () => {
    if ( !videoPlaying ) {
      setVideoPlaying(true);
    }
  };

  useEffect(() => {
    if (ref?.current) {
      if (inView) {
        ref.current.play().catch(error => {
          console.log('Video play error:', error);
        });
      } else {
        ref.current?.pause();
      }
    }
  }, [inView, ref?.current]);

  const playVideo = () => {
    if (ref?.current && videoLoaded) {
      ref.current.play().catch(error => {
        console.log('Video play error:', error);
      });
    }
  };

  const pauseVideo = () => {
    if (ref?.current) {
      ref.current.pause();
    }
  };

  useEffect(() => {
    if (shouldPause) {
      pauseVideo();
    } else {
      playVideo();
    }
  }, [shouldPause]);

  
  const getVideo =() => {
    return <video
      ref={ref}
      src={videoSrc}
      loop={true}
      muted
      playsInline
      autoPlay
      className={`${customClasses} ${videoPlaying ? "visible" : "invisible"}`}
      onPlay={handleVideoPlay}
      onCanPlay={handleVideoNotPlay}
      onError={handleVideoNotPlay}
      onPlaying={handleOnPlaying}
      {...rest}
    ></video>;
  };

  const getImage = () => {
    return <Image
      src={image}
      alt="Poster Image"
      layout="fill"
      className={`${customClasses}  ${videoPlaying ? "-z-[1]" : "z-[0]"}`}
      priority={priority}
    />;
  }
  return (
    <>
      {getVideo()}
      {getImage()}
    </>
  );
}

export default LazyVideo;
